<template>
  <div class="mi-site mi-site--page">
    <a class="mi-skip" href="#main">Skip to content</a>
    <MarketingHeader />

    <main id="main" class="mi-doc">
      <header class="mi-shell mi-doc-hero">
        <p class="mi-kicker">
          <span class="mi-kicker-dot" aria-hidden="true"></span>
          Legal
        </p>
        <h1>Terms of use</h1>
        <p class="mi-lede mi-lede--left">Effective August 19, 2026. MLS Ingest.</p>
      </header>

      <article class="mi-article">
        <div class="mi-article-inner">
          <p>
            These terms govern use of mlsingest.com and the MLS Ingest network
            (the “Service”). MLS Ingest is a Brokurz company. If you do
            not agree, do not use the Service.
          </p>

          <h2>The Service</h2>
          <p>
            MLS Ingest replicates MLS data over the RESO Web API and related
            vendor platforms and delivers it for authorized brokerage products,
            including Brokurz websites. Coverage, sync freshness, and board
            availability change. The
            <router-link to="/mls-directory">directory</router-link> and
            <router-link to="/status">status</router-link> pages are operational
            snapshots, not a guarantee.
          </p>

          <h2>MLS rules come first</h2>
          <p>
            Listing data is licensed by MLS boards and vendors. You may only
            receive or display it if the brokerage is authorized (membership,
            office/agent IDs, and a signed vendor / data-license agreement).
            IDX, VOW, and back-office rules of the source MLS still apply,
            including attribution, disclaimers, and sold/off-market handling.
          </p>
          <p>
            Do not scrape, resell, or republish MLS data from the Service
            outside that license. Do not share MLS credentials or ask brokers
            for Matrix / Flexmls passwords.
          </p>

          <h2>Accounts</h2>
          <p>
            Operator access is invite-only. You are responsible for activity
            under your login. We may suspend access if a license lapses, a
            board requires it, or the Service is abused.
          </p>

          <h2>Acceptable use</h2>
          <p>
            No unauthorized access, no interference with replication, no use
            of the Service to send spam, and no attempt to bypass MLS or vendor
            controls.
          </p>

          <h2>Intellectual property</h2>
          <p>
            MLS Ingest and Brokurz names, product UI, and documentation are
            ours or our licensors’. MLS content remains the MLS’s and the
            listing broker’s.
          </p>

          <h2>Disclaimer</h2>
          <p>
            The Service is provided “as is.” We do not warrant uninterrupted
            sync, complete coverage of every US board, or that a given listing
            is current at the second you view it. Real estate decisions require
            licensed professionals and the MLS of record.
          </p>

          <h2>Limitation of liability</h2>
          <p>
            To the fullest extent allowed by law, MLS Ingest and Brokurz are
            not liable for indirect, incidental, special, or consequential
            damages, or for lost deals, arising from the Service or from MLS
            data. Our aggregate liability for a claim relating to the Service
            is limited to fees you paid us for the Service in the twelve months
            before the claim, or one hundred dollars if there were no such fees.
          </p>

          <h2>Changes</h2>
          <p>
            We may update these terms. The effective date at the top will
            change. Continued use after an update is acceptance.
          </p>

          <h2>Contact</h2>
          <p>
            Questions: <a :href="'mailto:' + email">{{ email }}</a>
          </p>
        </div>
      </article>
    </main>

    <MarketingFooter />
  </div>
</template>

<script>
import MarketingHeader from './MarketingHeader'
import MarketingFooter from './MarketingFooter'
import { CONTACT_EMAIL } from '../lib/brand'
import '../assets/marketing.css'

export default {
  name: 'TermsPage',
  components: { MarketingHeader, MarketingFooter },
  data() {
    return { email: CONTACT_EMAIL }
  },
}
</script>
